export const USE_POINT = 'USE_POINT'
export const USE_POINT_SUCCESS = 'USE_POINT_SUCCESS'
export const USE_POINT_ERROR = 'USE_POINT_ERROR'

export const UsePoint = (data) => ({
  type: USE_POINT,
  payload: data
})
